export default __webpack_public_path__ + "static/media/icon-medapp.20921666.png";